import script from "./HistoricalVolatility.vue?vue&type=script&lang=js"
export * from "./HistoricalVolatility.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__